import { store } from 'v3/data/store';
import { onlineContractingSlice } from 'v3/data/store/onlineContracting';
import { OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';
import { filtersInitialState } from 'v3/data/store/onlineContracting/state';
import { FiltersType, OnlineContractingListType } from 'v3/data/store/onlineContracting/types';
import { IGetPaymentDetailsResponse } from 'v3/services/online/interfaces/response';

export const setOnlineContractingList = (list: OnlineContractingListType) => {
  store.dispatch(onlineContractingSlice.actions.setOnlineContractingList(list));
};

export const setFilterCurrentPage = (value: number) => {
  store.dispatch(onlineContractingSlice.actions.setFilterCurrentPage(value));
};

export const setFilterRowsPerPage = (value: number) => {
  store.dispatch(onlineContractingSlice.actions.setFilterRowsPerPage(value));
};

export const setStatusColor = (status: OnlineContractingStateEnum) => {
  store.dispatch(onlineContractingSlice.actions.setStatusColor(status));
};

export const setPaymentDetails = (paymentDetails: IGetPaymentDetailsResponse) => {
  store.dispatch(onlineContractingSlice.actions.setPaymentDetails(paymentDetails));
};

export const clearOnlineContractingInfo = () => {
  store.dispatch(onlineContractingSlice.actions.clearOnlineContractingInfo());
};

export const setFilters = (filters: FiltersType) => {
  store.dispatch(onlineContractingSlice.actions.setFilters(filters));
};

export const clearFilters = () => {
  store.dispatch(onlineContractingSlice.actions.setFilters(filtersInitialState));
};

export const setContractingOnlineState = (value: OnlineContractingStateEnum) => {
  store.dispatch(onlineContractingSlice.actions.setContractingState(value));
};

export const setContractingKey = (value: string) => {
  store.dispatch(onlineContractingSlice.actions.setContractingKey(value));
};
